const MontenegroSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111927)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M40 20.0002C40 13.1361 36.5415 7.08031 31.2724 3.47852H8.72758C3.45859 7.08031 0 13.1361 0 20.0002C0 26.8645 3.45859 32.9202 8.72758 36.522H31.2724C36.5415 32.9202 40 26.8645 40 20.0002Z"
        fill="#A2001D"
      />
      <path
        d="M15.6523 14.7828H24.348V11.3046L22.6088 12.1741L20.0002 9.56543L17.3915 12.1741L15.6523 11.3046V14.7828Z"
        fill="#FFDA44"
      />
      <path
        d="M27.8267 19.9999H23.4805C23.651 19.7051 23.75 19.3639 23.75 18.9989C23.75 17.8905 22.8515 16.9922 21.7433 16.9922C20.9776 16.9922 20.3126 17.4212 19.9742 18.0517C19.6359 17.4212 18.9709 16.9922 18.2052 16.9922C17.097 16.9922 16.1985 17.8905 16.1985 18.9989C16.1985 19.364 16.2977 19.7052 16.468 19.9999H12.1743C12.1743 21.3298 13.3327 22.4079 14.6625 22.4079H14.5824C14.5824 23.4987 15.3079 24.4198 16.3027 24.7157L14.3482 26.6703L16.1928 28.5149L18.8095 25.8983C18.912 25.9359 19.018 25.9659 19.1276 25.9865L17.5465 29.5564C18.3042 29.8645 19.1322 30.0355 20.0006 30.0355C20.8688 30.0355 21.6969 29.8645 22.4546 29.5564L20.8735 25.9865C20.9831 25.9659 21.0891 25.9359 21.1915 25.8983L23.8081 28.5149L25.6527 26.6703L23.6981 24.7158C24.6928 24.4198 25.4185 23.4988 25.4185 22.408H25.3382C26.6682 22.4079 27.8267 21.3298 27.8267 19.9999Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0004 21.3047L17.1743 22.609V25.2177L20.0004 26.9568L22.8265 25.2177V22.609L20.0004 21.3047Z"
        fill="#6DA544"
      />
      <path d="M17.1743 20H22.8265V23.4783H17.1743V20Z" fill="#0052B4" />
    </g>
    <defs>
      <clipPath id="clip0_4152_111927">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MontenegroSvg;
